export enum TSDatumTyp {
    VERFUEGUNGSDATUM = 'VERFUEGUNGSDATUM',
    EINREICHEDATUM = 'EINREICHEDATUM'
}
